import React, { useState } from 'react';
import { 
  Container, 
  Typography, 
  Box, 
  Paper, 
  TextField, 
  Button,
  Grid
} from '@mui/material';
import emailjs from '@emailjs/browser';

function Apie() {
  const [formData, setFormData] = useState({
    email: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    
    // Add validation for message length
    if (name === 'message' && value.length > 400) {
      return;
    }

    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    
    // Validate message length before submission
    if (formData.message.length > 400) {
      alert('Žinutė negali būti ilgesnė nei 400 simbolių.');
      return;
    }
    
    setLoading(true);

    try {
      await emailjs.send(
        'service_ppl5bbj', // from EmailJS
        'template_5pglr0q', // from EmailJS
        {
          from_email: formData.email,
          message: formData.message,
        },
        'n3tt17ipydwm_rDZJ' // from EmailJS
      );
      
      // Clear form
      setFormData({ email: '', message: '' });
      alert('Jūsų žinutė išsiųsta sėkmingai! Atsakysime Jums artimiausiu metu.');
    } catch (error) {
      console.error('Error sending email:', error);
      alert('Nepavyko išsiųsti žinutės. Prašome bandyti dar kartą.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'center', 
      minHeight: 'calc(100vh - 64px - 200px)' // Subtract AppBar and Footer approximate heights
    }}>
      <Container maxWidth="lg">
        {/* About Section */}
        <Box>
          <Typography variant="h2" component="h1" gutterBottom align="center" sx={{ mb: 10 }}>
            Apie mus
          </Typography>
          <Typography variant="body1" paragraph>
            Finsense - tai platforma skirta padėti JK studentams lengvai ir patogiai deklaruoti savo studijų įmokas VMI sistemoje. 
            Mūsų tikslas - supaprastinti deklaravimo procesą ir padėti studentams pasinaudoti tam skirtomis mokesčių lengvatomis.
          </Typography>
          <Typography variant="body1" paragraph>
            Mes suprantame, kad mokesčių deklaravimas gali būti sudėtingas procesas, 
            ypač kai dokumentai yra užsienio kalba ir Jungtinės Karalystės fiskaliniai metai nesutampa su Lietuvos fiskaliniais metais. 
            Tam pateikiame Jums mūsų įrankį, kuris automatiškai apdoroja Student Finance dokumentus ir paruošia juos VMI sistemai.
          </Typography>
        </Box>

        {/* Contact Form Section */}
        <Paper elevation={3} sx={{ p: 4, mb: 4 }}>
          <Typography variant="h4" gutterBottom>
            Susisiekite su mumis
          </Typography>
          <Typography variant="body1" sx={{ mb: 4 }}>
            Turite pasiūlymų arba klausimų? Susisiekite su mumis užpildę šią formą.
          </Typography>
          
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  label="El. paštas"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  label="Žinutė"
                  name="message"
                  multiline
                  rows={4}
                  value={formData.message}
                  onChange={handleChange}
                  helperText={`${formData.message.length}/400 simbolių`}
                  error={formData.message.length > 400}
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  size="large"
                  disabled={loading}
                >
                  {loading ? 'Siunčiama...' : 'Siųsti'}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Container>
    </Box>
  );
}

export default Apie; 